import styled from '@emotion/styled';

export const ClaimSummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
